import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-note-termini',
  templateUrl: './note-termini.component.html',
  styleUrls: ['./note-termini.component.css']
})
export class NoteTerminiComponent {

  @Input() note: any;
  @Input() termini: any;

  showNote = false;
  showTermini = false;

  terminiOrNote() {
    let ris = false;
    if ((this.note && this.note.length > 1) || (this.termini && this.termini.length > 1)) {
      ris = true;
    }
    return ris;
  }

  showPopUp(scelta) {
    switch (scelta) {
      case 1:
        this.showNote = this.showNote ? false : true;
        this.showTermini = false
        break;
      case 2:
        this.showTermini = this.showTermini ? false : true;
        this.showNote = false
        break;
    }
  }
}
